var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectToAnything(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 284,
    viewBox: "0 0 506 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.489 88.6814C144.632 88.6814 157.718 75.5949 157.718 59.452C157.718 43.3091 144.632 30.2227 128.489 30.2227C112.346 30.2227 99.2593 43.3091 99.2593 59.452C99.2593 75.5949 112.346 88.6814 128.489 88.6814Z",
    fill: "#FFD037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.149 149.526H76.7581C76.5786 149.528 76.3992 149.514 76.2223 149.484L144.039 32.0147C144.453 31.2831 145.054 30.6745 145.78 30.2511C146.506 29.8276 147.332 29.6045 148.172 29.6045C149.013 29.6045 149.838 29.8276 150.564 30.2511C151.29 30.6745 151.891 31.2831 152.305 32.0147L197.819 110.845L199.999 114.618L220.149 149.526Z",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M220.148 149.526H171.191L195.224 114.617L196.954 112.103L197.819 110.846L199.999 114.617L220.148 149.526Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.987 149.526H175.966L199.999 114.617L201.729 112.103L233.045 66.6101C235.099 63.6285 240.038 63.4429 242.452 66.0477C242.614 66.2254 242.764 66.4132 242.903 66.6101L299.987 149.526Z",
    fill: "#919191"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.393 130.201C341.257 130.201 345.2 126.257 345.2 121.393C345.2 116.528 341.257 112.585 336.393 112.585C331.528 112.585 327.585 116.528 327.585 121.393C327.585 126.257 331.528 130.201 336.393 130.201Z",
    fill: "#70C3A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.242 147.923H335.438L336.26 120.066L337.242 147.923Z",
    fill: "#70C3A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.419 125.346L338.356 122.666L336.392 126.009L336.18 125.638L336.419 125.346Z",
    fill: "#6F5AA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336.207 128.051L334.27 125.372L336.234 128.715L336.445 128.343L336.207 128.051Z",
    fill: "#6F5AA2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.188 130.201C422.052 130.201 425.995 126.257 425.995 121.393C425.995 116.528 422.052 112.585 417.188 112.585C412.323 112.585 408.38 116.528 408.38 121.393C408.38 126.257 412.323 130.201 417.188 130.201Z",
    fill: "#70C3A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M418.036 147.923H416.232L417.055 120.066L418.036 147.923Z",
    fill: "#70C3A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M417.214 125.346L419.151 122.666L417.188 126.009L416.975 125.638L417.214 125.346Z",
    fill: "#6F5AA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M417.002 128.051L415.065 125.372L417.029 128.715L417.241 128.343L417.002 128.051Z",
    fill: "#6F5AA2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M361.907 121.749C369.092 121.749 374.916 115.925 374.916 108.741C374.916 101.556 369.092 95.7324 361.907 95.7324C354.723 95.7324 348.899 101.556 348.899 108.741C348.899 115.925 354.723 121.749 361.907 121.749Z",
    fill: "#70C3A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 147.922H360.497L361.711 106.781L363.161 147.922Z",
    fill: "#70C3A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M361.946 114.578L364.807 110.621L361.907 115.558L361.594 115.009L361.946 114.578Z",
    fill: "#6F5AA2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M361.633 118.575L358.773 114.618L361.672 119.555L361.986 119.006L361.633 118.575Z",
    fill: "#6F5AA2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M393.63 121.749C400.814 121.749 406.639 115.925 406.639 108.741C406.639 101.556 400.814 95.7324 393.63 95.7324C386.446 95.7324 380.622 101.556 380.622 108.741C380.622 115.925 386.446 121.749 393.63 121.749Z",
    fill: "#70C3A6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M394.884 147.922H392.22L393.434 106.781L394.884 147.922Z",
    fill: "#70C3A6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M393.669 114.578L396.53 110.621L393.63 115.558L393.317 115.009L393.669 114.578Z",
    fill: "#6F5AA2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M393.356 118.575L390.496 114.618L393.395 119.555L393.709 119.006L393.356 118.575Z",
    fill: "#6F5AA2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M311.348 121.749C318.533 121.749 324.357 115.925 324.357 108.741C324.357 101.556 318.533 95.7324 311.348 95.7324C304.164 95.7324 298.34 101.556 298.34 108.741C298.34 115.925 304.164 121.749 311.348 121.749Z",
    fill: "#70C3A6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M312.602 147.922H309.938L311.153 106.781L312.602 147.922Z",
    fill: "#70C3A6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M311.388 114.578L314.248 110.621L311.349 115.558L311.035 115.009L311.388 114.578Z",
    fill: "#6F5AA2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M311.074 118.575L308.214 114.618L311.113 119.555L311.427 119.006L311.074 118.575Z",
    fill: "#6F5AA2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M465.25 283.085H40.7289C35.3803 283.085 30.0841 282.032 25.1426 279.985C20.2012 277.938 15.7113 274.938 11.9292 271.156C8.1472 267.374 5.14713 262.884 3.10031 257.943C1.05349 253.001 0 247.705 0 242.356C0 237.008 1.05349 231.711 3.10031 226.77C5.14713 221.828 8.1472 217.339 11.9292 213.557C15.7113 209.774 20.2012 206.774 25.1426 204.728C30.0841 202.681 35.3803 201.627 40.7289 201.627H464.31C468.464 201.627 472.449 199.977 475.387 197.039C478.324 194.101 479.975 190.117 479.975 185.962C479.975 181.808 478.324 177.823 475.387 174.886C472.449 171.948 468.464 170.297 464.31 170.297H26.6305V145.233H464.31C475.112 145.233 485.471 149.524 493.109 157.163C500.748 164.801 505.039 175.16 505.039 185.962C505.039 196.764 500.748 207.124 493.109 214.762C485.471 222.4 475.112 226.691 464.31 226.691H40.7289C36.5743 226.691 32.5899 228.342 29.6521 231.279C26.7144 234.217 25.064 238.202 25.064 242.356C25.064 246.511 26.7144 250.495 29.6521 253.433C32.5899 256.371 36.5743 258.021 40.7289 258.021H465.25V283.085Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.72 157.139H42.2954V158.392H61.72V157.139Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M116.861 157.139H97.4362V158.392H116.861V157.139Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M172.001 157.139H152.577V158.392H172.001V157.139Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M227.142 157.139H207.718V158.392H227.142V157.139Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M282.283 157.139H262.858V158.392H282.283V157.139Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M337.424 157.139H317.999V158.392H337.424V157.139Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M392.564 157.139H373.14V158.392H392.564V157.139Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M447.705 157.139H428.28V158.392H447.705V157.139Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.72 213.533H42.2954V214.786H61.72V213.533Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.861 213.533H97.4362V214.786H116.861V213.533Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.001 213.533H152.577V214.786H172.001V213.533Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.142 213.533H207.718V214.786H227.142V213.533Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M282.283 213.533H262.858V214.786H282.283V213.533Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M337.424 213.533H317.999V214.786H337.424V213.533Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M392.564 213.533H373.14V214.786H392.564V213.533Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M447.705 213.533H428.28V214.786H447.705V213.533Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.72 269.927H42.2954V271.18H61.72V269.927Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.861 269.927H97.4362V271.18H116.861V269.927Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.001 269.927H152.577V271.18H172.001V269.927Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M227.142 269.927H207.718V271.18H227.142V269.927Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M282.283 269.927H262.858V271.18H282.283V269.927Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M337.424 269.927H317.999V271.18H337.424V269.927Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M392.564 269.927H373.14V271.18H392.564V269.927Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M447.705 269.927H428.28V271.18H447.705V269.927Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M335.474 49.7363C337.515 49.7344 339.522 50.2531 341.306 51.2434H329.656C331.435 50.2534 333.438 49.7347 335.474 49.7363Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M312.867 48.2295C316.276 48.2255 319.602 49.2786 322.388 51.2437H303.36C306.142 49.2809 309.463 48.2279 312.867 48.2295Z",
    fill: "#E6E6E6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M184.811 29.1509C185.225 21.8407 188.221 14.9148 193.266 9.60822C198.311 4.30162 205.076 0.95921 212.356 0.176908C219.636 -0.605394 226.958 1.22327 233.015 5.33686C239.072 9.45045 243.471 15.5816 245.429 22.6371C245.803 22.6237 246.177 22.6086 246.554 22.6086C253.229 22.6099 259.724 24.7723 265.068 28.7723C270.411 32.7724 274.316 38.3951 276.198 44.7992C280.621 42.8557 285.564 42.4341 290.252 43.6003C294.94 44.7665 299.11 47.4546 302.107 51.2437H205.733C202.922 51.2517 200.137 50.6922 197.547 49.5988C194.957 48.5054 192.614 46.9006 190.658 44.8805C188.703 42.8603 187.175 40.4663 186.167 37.8419C185.158 35.2174 184.69 32.4164 184.789 29.6066C184.796 29.455 184.803 29.3031 184.811 29.1509Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M342.506 72.294C340.466 72.292 338.458 72.8108 336.674 73.8011H348.324C346.545 72.8111 344.542 72.2923 342.506 72.294Z",
    fill: "#E6E6E6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M365.113 70.7871C361.704 70.7831 358.378 71.8362 355.592 73.8013H374.62C371.839 71.8385 368.517 70.7855 365.113 70.7871Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M493.169 51.7086C492.756 44.3983 489.759 37.4724 484.714 32.1658C479.67 26.8592 472.904 23.5168 465.624 22.7345C458.344 21.9522 451.023 23.7809 444.965 27.8945C438.908 32.0081 434.509 38.1392 432.552 45.1947C432.177 45.1813 431.803 45.1663 431.426 45.1663C424.751 45.1675 418.256 47.3299 412.912 51.3299C407.569 55.33 403.664 60.9527 401.782 67.3568C397.359 65.4134 392.417 64.9917 387.728 66.1579C383.04 67.3241 378.871 70.0122 375.874 73.8013H472.247C475.059 73.8093 477.843 73.2498 480.433 72.1564C483.023 71.063 485.366 69.4582 487.322 67.4381C489.277 65.4179 490.805 63.0239 491.813 60.3995C492.822 57.775 493.29 54.974 493.191 52.1642C493.185 52.0126 493.177 51.8607 493.169 51.7086Z",
    fill: "#E6E6E6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M428.918 265.57L440.119 265.576L440.12 263.798L428.919 263.792L428.918 265.57Z",
    fill: "#6F5AA2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M347.934 264.193L350.245 264.728L438.075 264.775L438.864 262.935C440.242 259.778 440.715 256.301 440.23 252.892C439.852 250.35 438.904 247.825 436.751 246.728L432.853 220.769L384.262 220.682L365.462 235.845C365.462 235.845 356.594 235.685 351.776 241.683C350.038 243.914 349.012 246.615 348.831 249.437L348.641 252.557L347.934 264.193Z",
    fill: "#6F5AA2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M367.225 274.605C373.214 274.605 378.07 269.749 378.07 263.759C378.07 257.77 373.214 252.914 367.225 252.914C361.235 252.914 356.379 257.77 356.379 263.759C356.379 269.749 361.235 274.605 367.225 274.605Z",
    fill: "#6F5AA2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M367.225 269.468C370.377 269.468 372.933 266.912 372.933 263.76C372.933 260.607 370.377 258.052 367.225 258.052C364.072 258.052 361.517 260.607 361.517 263.76C361.517 266.912 364.072 269.468 367.225 269.468Z",
    fill: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M420.74 274.633C426.73 274.633 431.585 269.777 431.585 263.788C431.585 257.798 426.73 252.942 420.74 252.942C414.75 252.942 409.895 257.798 409.895 263.788C409.895 269.777 414.75 274.633 420.74 274.633Z",
    fill: "#6F5AA2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M420.74 269.496C423.893 269.496 426.448 266.941 426.448 263.788C426.448 260.636 423.893 258.08 420.74 258.08C417.588 258.08 415.032 260.636 415.032 263.788C415.032 266.941 417.588 269.496 420.74 269.496Z",
    fill: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M372.931 234.073L399.167 234.084H402.369L407.776 234.088V233.693L407.78 228.938L407.784 223.599H404.186L400.984 223.596L395.311 223.592H392.108L385.559 223.588L372.931 234.073Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M412.045 234.092L425.91 234.099L425.914 231.379V226.624L425.918 223.611H423.887L420.685 223.607L412.049 223.604L412.045 234.092Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M405.993 245.289L407.771 245.29L407.773 241.912L405.995 241.911L405.993 245.289Z",
    fill: "#6F5AA2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M380.039 238.875L380.04 237.097L376.662 237.095L376.661 238.873L380.039 238.875Z",
    fill: "#6F5AA2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M378.795 237.879L378.599 237.879C378.111 237.879 377.628 237.782 377.177 237.595C376.727 237.408 376.317 237.134 375.972 236.789C375.628 236.444 375.354 236.034 375.168 235.583C374.981 235.132 374.885 234.649 374.885 234.161C374.886 233.673 374.982 233.19 375.169 232.739C375.356 232.288 375.63 231.879 375.975 231.534C376.32 231.189 376.73 230.916 377.181 230.729C377.632 230.543 378.115 230.447 378.603 230.447L378.799 230.447L378.795 237.879Z",
    fill: "#6F5AA2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M348.641 252.557C349.985 252.703 351.338 252.37 352.461 251.616C353.584 250.863 354.406 249.737 354.78 248.438C355.155 247.138 355.059 245.748 354.509 244.512C353.96 243.277 352.992 242.275 351.776 241.683C350.038 243.913 349.011 246.615 348.831 249.436L348.641 252.557Z",
    fill: "#6F5AA2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M400.984 223.596L407.776 233.693L407.78 228.938L404.186 223.599L400.984 223.596Z",
    fill: "#F2F2F2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M420.685 223.607L425.914 231.379V226.624L423.888 223.611L420.685 223.607Z",
    fill: "#F2F2F2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M392.109 223.592L399.167 234.084H402.369L395.311 223.592H392.109Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectToAnything);
export default __webpack_public_path__ + "static/media/connect-to-anything.31628031a093e1c4a6348302fd538d48.svg";
export { ForwardRef as ReactComponent };